import { Button, Flex } from "@chakra-ui/react";
import { useNewOrderStore } from "../../../stores/order.store";
import { LoaderCircle } from "lucide-react";

/**
 * Base layout buttons. Go back and continue.
 */
export const OrdersNewPageBaseLayoutValidate = ({
	onValidate,
	onValidateAndSee,
	onValidatePending,
	onValidateAndSeePending,
}: {
	onValidate?: () => void;
	onValidateAndSee?: () => void;
	onValidatePending?: boolean;
	onValidateAndSeePending?: boolean;
}) => {
	const { goPreviousStep, canGoNextStep } = useNewOrderStore();

	const handleValidate = async () => {
		if (onValidate) {
			return onValidate();
		}
	};
	const handleValidateAndSee = async () => {
		if (onValidateAndSee) {
			return onValidateAndSee();
		}
	};
	return (
		<Flex
			className="fixed bottom-0 w-full border-t! border-gray-300! bg-white! shadow-sm! flex justify-between p-4"
			gap="4"
		>
			<Button variant="outline" w="fit-content" onClick={goPreviousStep}>
				Retour
			</Button>
			<div className="flex gap-2">
				<Button
					w="fit-content"
					isDisabled={
						!canGoNextStep() || onValidatePending || onValidateAndSeePending
					}
					onClick={handleValidate}
					variant="outline"
					className="flex gap-2"
				>
					{onValidatePending && <LoaderCircle className="animate-spin" />}
					Valider la commande
				</Button>
				<Button
					w="fit-content"
					isDisabled={
						!canGoNextStep() || onValidatePending || onValidateAndSeePending
					}
					onClick={handleValidateAndSee}
					colorScheme="brand"
					className="flex gap-2"
				>
					{onValidateAndSeePending && <LoaderCircle className="animate-spin" />}
					Valider & voir le bon
				</Button>
			</div>
		</Flex>
	);
};
